(() => {
  const STORAGE_KEY = 'dupsaQuoteItemsV1';
  const WHATSAPP = 'https://wa.me/524771218907';
  const readItems = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.filter((item) => item && item.id && item.title && item.url) : [];
    } catch (_) { return []; }
  };
  const writeItems = (items) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('dupsa:quote-updated'));
  };
  const safeProductUrl = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      if (url.protocol !== 'https:' || !(url.hostname === window.location.hostname || url.hostname.endsWith('.myshopify.com'))) return window.location.origin;
      return url.href;
    } catch (_) { return window.location.origin; }
  };
  const drawer = document.getElementById('DupsaQuoteDrawer');
  const list = drawer?.querySelector('[data-quote-items]');
  const counts = [...document.querySelectorAll('[data-quote-count]')];
  const countText = drawer?.querySelector('[data-quote-count-text]');
  const whatsappLinks = [...document.querySelectorAll('[data-quote-whatsapp]')];

  drawer?.addEventListener('click', (event) => {
    if (event.target === drawer) drawer.close();
  });

  const render = () => {
    const items = readItems();
    const quantity = items.reduce((sum, item) => sum + Math.max(1, Number(item.quantity) || 1), 0);
    counts.forEach((node) => {
      node.textContent = String(quantity);
      if (node.hasAttribute('data-quote-header-count')) node.hidden = quantity === 0;
    });
    if (countText) countText.textContent = `(${quantity})`;
    if (list) {
      list.replaceChildren();
      if (!items.length) {
        const empty = document.createElement('p');
        empty.className = 'dupsa-quote-empty';
        empty.textContent = 'Aún no agregas productos. Explora el catálogo y suma los que quieras cotizar.';
        list.append(empty);
      }
      items.forEach((item) => {
        const row = document.createElement('article');
        row.className = 'dupsa-quote-item';
        const title = document.createElement('a');
        title.href = safeProductUrl(item.url);
        title.textContent = item.title;
        const variant = document.createElement('span');
        variant.className = 'dupsa-quote-variant';
        variant.textContent = item.variantTitle && item.variantTitle !== 'Default Title' ? item.variantTitle : 'Precio por cotizar';
        const actions = document.createElement('div');
        actions.className = 'dupsa-quote-item__actions';
        [['−', -1], [String(Math.max(1, Number(item.quantity) || 1)), 0], ['+', 1]].forEach(([label, delta]) => {
          const control = document.createElement('button');
          control.type = 'button';
          control.textContent = label;
          control.setAttribute('aria-label', delta === 0 ? `Cantidad: ${label}` : `${delta < 0 ? 'Reducir' : 'Aumentar'} cantidad de ${item.title}`);
          if (delta === 0) control.disabled = true;
          else control.addEventListener('click', () => {
            const next = readItems().map((entry) => entry.id === item.id ? { ...entry, quantity: Math.max(1, (Number(entry.quantity) || 1) + delta) } : entry);
            writeItems(next);
          });
          actions.append(control);
        });
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'dupsa-quote-item__remove';
        remove.textContent = 'Quitar';
        remove.addEventListener('click', () => writeItems(readItems().filter((entry) => entry.id !== item.id)));
        row.append(title, variant, actions, remove);
        list.append(row);
      });
    }
    const message = ['Hola, quisiera solicitar una cotización de estos productos:', ...items.map((item) => `• ${item.title}${item.variantTitle && item.variantTitle !== 'Default Title' ? ` (${item.variantTitle})` : ''} — cantidad: ${Math.max(1, Number(item.quantity) || 1)}\n${safeProductUrl(item.url)}`)].join('\n\n');
    whatsappLinks.forEach((link) => {
      link.href = `${WHATSAPP}?text=${encodeURIComponent(message)}`;
      link.hidden = !items.length;
    });
    const summary = document.querySelector('[data-quote-summary]');
    const hiddenMessage = document.querySelector('[data-quote-message]');
    const submit = document.querySelector('[data-quote-submit]');
    if (summary) {
      summary.replaceChildren();
      if (!items.length) {
        const empty = document.createElement('p');
        empty.textContent = 'Tu lista está vacía. Agrega productos bajo pedido antes de enviar.';
        summary.append(empty);
      } else items.forEach((item) => {
        const line = document.createElement('p');
        line.textContent = `${item.title}${item.variantTitle && item.variantTitle !== 'Default Title' ? ` (${item.variantTitle})` : ''} — cantidad: ${Math.max(1, Number(item.quantity) || 1)} — ${safeProductUrl(item.url)}`;
        summary.append(line);
      });
    }
    if (hiddenMessage) hiddenMessage.value = `Solicitud de cotización DUPSA\n\nProductos:\n${items.map((item) => `- ${item.title}${item.variantTitle && item.variantTitle !== 'Default Title' ? ` (${item.variantTitle})` : ''}; cantidad: ${Math.max(1, Number(item.quantity) || 1)}; ${safeProductUrl(item.url)}`).join('\n')}`;
    if (submit) submit.disabled = !items.length;
  };

  document.addEventListener('click', (event) => {
    const add = event.target.closest('[data-add-to-quote]');
    if (add) {
      const cardVariantSelect = add.closest('.product-card')?.querySelector('[data-product-variant-select]');
      const productForm = add.closest('product-information, .product-information, section')?.querySelector('form[action*="/cart/add"]');
      const variantInput = productForm?.querySelector('[name="id"]');
      const productPicker = add.closest('product-information, .product-information, section')?.querySelector('variant-picker[data-template-product-match="true"]');
      const selectedOptions = productPicker ? [...productPicker.querySelectorAll('fieldset')].map((fieldset) => fieldset.querySelector('input:checked')?.value).filter((value) => value != null) : [];
      const urlVariantId = new URL(window.location.href).searchParams.get('variant');
      let variantId = cardVariantSelect?.value || variantInput?.value || urlVariantId || add.dataset.variantId || '';
      let variantTitle = add.dataset.variantTitle || '';
      try {
        const variantIds = JSON.parse(add.dataset.variantIds || '[]').map(String);
        const variantTitles = JSON.parse(add.dataset.variantTitles || '[]');
        const variantOptions = JSON.parse(add.dataset.variantOptions || '[]');
        let selectedIndex = variantIds.indexOf(String(variantId));
        if (cardVariantSelect) selectedIndex = variantIds.indexOf(String(cardVariantSelect.value));
        else if (selectedOptions.length && variantOptions.length) {
          const optionMatch = variantOptions.findIndex((options) => options.length === selectedOptions.length && options.every((value, index) => value === selectedOptions[index]));
          if (optionMatch >= 0) selectedIndex = optionMatch;
        }
        if (selectedIndex >= 0) variantId = variantIds[selectedIndex];
        if (selectedIndex >= 0) variantTitle = variantTitles[selectedIndex] || variantTitle;
      } catch (_) {}
      const id = `${add.dataset.productId}:${variantId}`;
      const quantity = 1;
      const items = readItems();
      const existing = items.find((item) => item.id === id);
      if (existing) existing.quantity = (Number(existing.quantity) || 1) + quantity;
      else items.push({ id, productId: add.dataset.productId, variantId, title: add.dataset.productTitle, variantTitle, url: safeProductUrl(add.dataset.productUrl), quantity });
      writeItems(items);
      if (drawer && !drawer.open) drawer.showModal();
      return;
    }
    if (event.target.closest('[data-quote-open]') && drawer && !drawer.open) drawer.showModal();
    if (event.target.closest('[data-quote-close]') && drawer?.open) drawer.close();
  });
  document.addEventListener('dupsa:quote-updated', render);
  window.addEventListener('storage', (event) => { if (event.key === STORAGE_KEY) render(); });
  const form = document.getElementById('QuoteRequestForm');
  if (form) form.addEventListener('submit', (event) => {
    const items = readItems();
    if (!items.length) { event.preventDefault(); render(); return; }
    const message = document.querySelector('[data-quote-message]');
    const comments = document.getElementById('QuoteComments')?.value.trim();
    if (message && comments) message.value += `\n\nComentarios del cliente:\n${comments}`;
  });
  if (document.querySelector('[data-quote-success="true"]')) localStorage.removeItem(STORAGE_KEY);
  render();
})();
